// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contratos_MinutaAcaoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /contratos/minuta_aprovar e /contratos/minuta_descartar — qual minuta (Full). */
import { registerContract } from './validate'

export interface Contratos_MinutaAcaoInput {
minuta_id?: number
}

registerContract('Contratos_MinutaAcaoInput', {
  minuta_id: { type: 'number',  required: false },
})
